<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
		<el-form :inline="true" class="backborder1 demo-form-inline" size="small">
			<el-form-item style="width:10%">
				<el-select v-model="query.datetype" @change="changedatetype">
					<el-option v-for="(item,index) in datetype" :key="index" :label="item.name" :value="item.id"></el-option>
				</el-select> 
			</el-form-item>
			
			<!-- 日期 -->
			<el-form-item style="width:12%" v-if="query.datetype==1">
				<el-date-picker v-model="query.starttime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择开始日期" style="width:100%"></el-date-picker>
			</el-form-item>
			<el-form-item style="width:12%" v-if="query.datetype==1">
				<el-date-picker v-model="query.endtime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择结束日期" style="width:100%"></el-date-picker>
			</el-form-item>
			<!-- 月份 -->
			<el-form-item style="width:12%" v-if="query.datetype==2">
				<el-date-picker v-model="query.starttime" type="month" format="yyyy-MM" value-format="yyyy-MM" placeholder="选择开始日期" style="width:100%"></el-date-picker>
			</el-form-item>
			<el-form-item style="width:12%" v-if="query.datetype==2">
				<el-date-picker v-model="query.endtime" type="month" format="yyyy-MM" value-format="yyyy-MM" placeholder="选择结束日期" style="width:100%"></el-date-picker>
			</el-form-item>
			<!-- 年份 -->
			<el-form-item style="width:12%" v-if="query.datetype==3">
				<el-date-picker v-model="query.starttime" type="year" format="yyyy" value-format="yyyy" placeholder="选择开始日期" style="width:100%"></el-date-picker>
			</el-form-item>
			<el-form-item style="width:12%" v-if="query.datetype==3">
				<el-date-picker v-model="query.endtime" type="year" format="yyyy" value-format="yyyy" placeholder="选择结束日期" style="width:100%"></el-date-picker>
			</el-form-item>

            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
				<el-button type="primary" icon="el-icon-document" @click="gomallsales">销售记录</el-button>
				<!--
				<el-button type="primary" icon="el-icon-document" @click="mallrefund">退货记录</el-button>
				-->
				<el-button type="danger" icon="el-icon-edit-outline" @click="mallsellsstat">销售统计</el-button>
				<!--
				<el-button type="danger" icon="el-icon-edit-outline" @click="mallrefundstat">退货统计</el-button>
				-->
				<el-button type="warning" icon="el-icon-time" @click="mallday">销售日结</el-button>
            </el-form-item>
      	</el-form>

		<el-tag type="danger" closable  @close="closetag" v-if="tagshow" style="margin-top:10px">温馨提示：未发货的订单，其所包含的商品成本一律为 0</el-tag>


		<div class="sales backborder2" style="margin-top:10px" v-loading="saledataLoading">
			<p>销售数据</p>
			<ul>
			    <li class="rightborder">
					<span class="title">订单数</span>
					<span class="number">{{saledatas.ordernum}}</span>
					<div class="desc"><span>客流量</span><i>{{saledatas.shopnum}}人</i></div>
					<div class="desc"><span>客单价</span><i>{{saledatas.orderamount}}元</i></div>
				</li>
				<li class="rightborder">
					<span class="title">销售金额</span>
					<span class="number">{{saledatas.sales}} <i>元</i></span>
					<div class="desc"><span>宠赞商品</span><i>{{saledatas.agentsales}}元</i></div>
					<div class="desc"><span>京东商品</span><i>{{saledatas.jdsales}}元</i></div>
				</li>
				<li class="rightborder">
					<span class="title">销售成本</span>
					<span class="number">{{saledatas.sellcosts}} <i>元</i></span>
					<div class="desc"><span>宠赞商品</span><i>{{saledatas.agentcosts}}元</i></div>
					<div class="desc"><span>京东商品</span><i>{{saledatas.jdcosts}}元</i></div>
				</li>
				<li>
					<span class="title">销售利润</span>
					<span class="number">{{saledatas.allprofit}} <i>元</i></span>
					<div class="desc"><span>宠赞商品</span><i>{{saledatas.agentprofit}}元</i></div>
					<div class="desc"><span>京东商品</span><i>{{saledatas.jdprofit}}元</i></div>
				</li>
			</ul>
		</div>

		<div class="sales backborder2" style="margin-top:10px" v-loading="dealLoading">
			<p>营销数据</p>
			<ul>
				<li style="width:16%">
					<span class="title">当前活动数量</span>
					<span class="number1">{{dealdatas.activenumbers}}</span>
				</li>
				<li style="width:16%">
					<span class="title">赠品数量</span>
					<span class="number1">{{dealdatas.giftnumbers}}</span>
				</li>
				<li style="width:16%">
					<span class="title">赠送成本</span>
					<span class="number1">{{dealdatas.giftcost}}</span>
				</li>
				<li style="width:16%">
					<span class="title">优惠金额</span>
					<span class="number1">{{dealdatas.prefers}}</span>
				</li>
				<li style="width:16%">
					<span class="title">代金券</span>
					<span class="number1">{{dealdatas.couponums}}次</span>
				</li>
				<li style="width:16%">
					<span class="title">代金券金额</span>
					<span class="number1">{{dealdatas.couponmoney}}</span>
				</li>
			</ul>
		</div>

		<div class="sales backborder2" style="margin-top:10px;" v-loading="sellandcostLoading">
			<p>日结数据</p>
			<div class="backborder6" style="width:96%;margin-left:1%;margin-top:10px">
				<IEcharts :option="income" :loading="incomeLoading"/>
    		</div>
		</div>

	</div>
    </transition>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js';
export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Mallstat/index",
      transitionshow:true,
      actionauth:[],
	  query: {
		  act:'getsalesdata',
		  token:this.$cookies.get('token'),
		  datetype:1,
		  starttime:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
		  endtime:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
	  },
	  datetype:[{id:1,name:'按日期'},{id:2,name:'按月份'},{id:3,name:'按年份'}],
	  saledatas:[],
	  dealdatas:[],
	  sellcostdatas:[],
	  saledataLoading:false,
	  dealLoading:false,
	  sellandcostLoading:false,
	  tagshow:true,

	  incomeLoading:false,
	  income: {		 
		 legend: {
			data:['销售金额','销售成本']
		 },
		 grid: {
		 	 left: '3%',
			 right: '4%',
			 bottom: '3%',
			 containLabel: true
    	 },
		 tooltip: {
			 trigger: 'axis' //axis item none三个值
		 },
		 xAxis: [
			 {			  
				type: 'category', // 还有其他的type，可以去官网喵两眼哦
				data: ['周一','周二','周三','周四','周五','周六','周日'], // x轴数据
				name: '', //x轴名称
				nameTextStyle: { //x轴名称样式
					fontWeight: 600,
					fontSize: 18,
				}
			 }		  
		 ],
		 yAxis: {
			 type: 'value',
			 name: '', //y轴名称
			 nameTextStyle: { //y轴名称样式
				 fontWeight: 600,
				 fontSize: 18
			 }    
		 },
		 series: [
			{
				name: '销售金额',
				data: [120, 132, 101, 134, 90, 230, 210],
				type: 'bar',
				stack: "1",
				itemStyle : {
					normal : {
						color:'#67C23A',
						lineStyle:{color:'#67C23A'}
					}
				},
			},
			{
			    name: '销售成本',
			    data: [150, 232, 201, 154, 190, 330, 410],
			    type: 'bar',
				stack: "1",
				itemStyle : {
					normal : {
						color:'#E6A23C',
						lineStyle:{color:'#E6A23C'}
					}
				},
			},			  		
		]
     },


    }
  },
  mounted(){    
  	  this.getactionauth(); //获取权限设置
	  this.getList(); //获取销售数据记录
  },

  components: {
      IEcharts
  },
  
  methods:{
    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

	/** 切换时间类型 **/
	changedatetype() {
		this.query.starttime='';
		this.query.endtime='';
	},

	/** 按时间搜索 **/
	getList() {
		this.mallsales();	
		this.getdealdatas();
		this.getsellandcost();
	},

	/** 跳转销售记录 **/
	gomallsales() {
		this.$emit('listenchild',{name:'线上商城销售记录',url:'mallsellstats'});
	},

	/** 跳转销售统计 **/
	mallsellsstat() {
		this.$emit('listenchild',{name:'线上商城销售统计',url:'mallselldetail'});
	},

	/** 跳转销售日结统计 **/
	mallday() {
		this.$emit('listenchild',{name:'线上商城销售日结',url:'malldaystats'});
	},

	//////////////////////////////////////////////////
	
	/** 销售记录 **/
    mallsales() {
		this.saledataLoading=true;
		var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.saledataLoading=false;
			}else{
				this.saledatas = JSON.parse(Base64.decode(res.data.Data));
				this.saledataLoading=false;
			}
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
			this.saledataLoading=false;
        });
	},
	

	/** 获取营销数据 **/
	getdealdatas() {
		this.dealLoading=true;
		var resource = this.$resource(this.url);
        resource.query({act:'getdealdatas',token:this.$cookies.get('token'),datetype:this.query.datetype,starttime:this.query.starttime,endtime:this.query.endtime}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.dealLoading=false;
			}else{
				this.dealdatas = JSON.parse(Base64.decode(res.data.Data));
				this.dealLoading=false;
			}
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
			this.dealLoading=false;
        });
	},

	/** 获取销售、成本数据 **/
	getsellandcost() {
		this.sellandcostLoading=true;
		var resource = this.$resource(this.url);
        resource.query({act:'getsellandcost',token:this.$cookies.get('token'),datetype:this.query.datetype,starttime:this.query.starttime,endtime:this.query.endtime}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.sellandcostLoading=false;
			}else{
				this.sellcostdatas = JSON.parse(Base64.decode(res.data.Data));
				this.income.xAxis[0].data=[];
				this.income.series[0].data=[];
				this.income.series[1].data=[];
				let _this=this;

				this.sellcostdatas.days.forEach(function(item,i) {
					_this.income.xAxis[0].data.push(item);
				});
				this.sellcostdatas.sells.forEach(function(item,i) {
					_this.income.series[0].data.push(item);
				});
				this.sellcostdatas.costs.forEach(function(item,i) {
					_this.income.series[1].data.push(item);
				});

				this.income.xAxis[0].data=this.sellcostdatas.days;
				this.income.series[0].data=this.sellcostdatas.sells;
				this.income.series[1].data=this.sellcostdatas.costs;
				this.sellandcostLoading=false;
			}
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
			this.sellandcostLoading=false;
        });
	},

	closetag() {
		this.tagshow=false;
	},

     
  }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.backborder6 {float:left;padding:2% 1% 2% 1%;height:300px;background:#fff;border-radius:5px;border:none}
.sales {float:left;width:98%;vertical-align:middle;}
.sales p {float:left;width:98%;margin-left:2%;color:#303133;font-size:.93rem;font-weight:bold}
.sales ul {padding:0;margin:0;float:left;width:100%;}
.sales ul li {list-style-type:none;float:left;width:24%;padding:1% 0 1% 0;text-align:center}
.sales li .title {float:left;width:100%;text-align:center;font-size:.9rem;color:#909399}
.sales li .number {float:left;width:100%;text-align:center;font-size:1.2rem;color:#F56C6C;line-height:1.5rem;font-weight:bold;padding:1rem 0 1rem 0;}
.sales li .number i {font-style:normal;font-size:.8rem}
.sales li .number1 {float:left;width:100%;text-align:center;font-size:.9rem;color:#303133;padding:1rem 0 1rem 0;}
.sales li .desc {float:right;width:100%;font-size:.9rem;padding:.2rem 0 .2rem 0;border-bottom:0;margin-top:0}
.sales li .desc span {float:left;width:40%;text-align:right;color:#909399;}
.sales li .desc i {float:left;width:60%;text-align:left;font-style:normal;color:#303133;text-indent:5%;}
.leftborder {border-left:1px solid #ddd}
.rightborder {border-right:1px solid #ddd}
</style>


// WEBPACK FOOTER //
// src/components/stat/StatmallSale.vue